import React from "react";
import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { GallerySection } from "../components/GallerySection";
import { BUSINESS_INFO } from "../config";

export function GalleryPage() {
  return (
    <>
      <SEO
        title="Galleri - Hundens Pels og Pleje"
        description="Se billeder fra Hundens Pels og Pleje i Fredericia. Billeder af klip, vask, føn og glade hunde på trimmebordet i salonen."
      />

      {/* Hero header without background box */}
      <section className="pt-12 pb-6 sm:pt-16 sm:pb-8">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-black">
            Galleri
          </h1>
          <p className="mt-4 text-base sm:text-lg text-neutral-700 max-w-2xl mx-auto leading-relaxed">
            Se glimt af hverdagen hos Hundens Pels og Pleje i Fredericia. Her kan du opleve vores rolige omgivelser, udstyr og de skønne firbenede gæster på trimmebordet.
          </p>
        </div>
      </section>

      {/* Full Gallery Section */}
      <GallerySection
        title="Billeder af vores arbejde & salonen"
        subtitle="Klik på ethvert billede for at se det i stor visning. Filtrer gerne efter behandlingstype."
        showTabs={true}
      />

      {/* Booking CTA Section */}
      <section className="py-12 bg-[#F3ECE4] border-t border-[#E5D9CC]">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading text-2xl sm:text-3xl font-medium text-black">
            Skal din hund også forkæles med en kærlig behandling?
          </h2>
          <p className="mt-3 text-base text-neutral-700 max-w-xl mx-auto leading-relaxed">
            Book tid nemt online eller ring til os, hvis du har særlige ønsker eller spørgsmål til din hunds pelspleje.
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-4">
            <a
              href={BUSINESS_INFO.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-[#dabeb9] px-7 py-3.5 text-sm font-medium tracking-wide text-black shadow-xs transition-colors hover:bg-[#c9a7a0]"
            >
              <i className="fa-solid fa-calendar-check text-black" aria-hidden="true" />
              <span>Book tid online</span>
            </a>
            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 rounded-full border border-black bg-transparent px-6 py-3.5 text-sm font-medium tracking-wide text-black transition-colors hover:bg-black hover:text-white whitespace-nowrap"
            >
              <i className="fa-solid fa-comment-dots text-current" aria-hidden="true" />
              <span>Kontakt os</span>
            </Link>
            <a
              href={`tel:${BUSINESS_INFO.phoneRaw}`}
              className="inline-flex items-center gap-2 rounded-full border border-neutral-400 bg-transparent px-5 py-3.5 text-sm font-medium text-neutral-800 transition-colors hover:border-black hover:text-black whitespace-nowrap"
            >
              <i className="fa-solid fa-phone text-black" aria-hidden="true" />
              <span className="whitespace-nowrap">{BUSINESS_INFO.phone}</span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
